var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/H2Extension.ts
import { css } from "@adornis/chemistry/directives/css.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import "@adornis/fonts/fonts.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import sanitizeHtml from "sanitize-html";
import { BaseH2 } from "../../db/extensions/text/BaseH2.js";
import { ExtensionBoilerplate } from "./ContentExtensionBoilerplate.js";
import "./H1Extension.js";
import { H1Extension } from "./H1Extension.js";
var H2Extension = {
  class: BaseH2,
  toolbar: { icon: "format_h2", text: { default: "H2" } },
  render(instance, { defaultValues, isSubelement, dropzoneBefore, dropzoneAfter }) {
    return xComponents(html`
      <x-h2-extension
        .content=${instance}
        .defaultValues=${defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></x-h2-extension>
    `);
  },
  editor: H1Extension.editor,
  group: "Schriften"
};
var XH2Extension = class extends ExtensionBoilerplate {
  _content(content) {
    const emptyPlaceholder = html`
      <x-h2 ${css({ color: this.colors.tone.warning })}> Der Text muss mindestens ein Zeichen lang sein! </x-h2>
    `;
    if (!content.text)
      return emptyPlaceholder;
    return html`
      <x-h2 ${css({ textAlign: content.textAlign ?? "unset", width: "100%" })}>
        ${unsafeHTML(sanitizeHtml(content.text))}
      </x-h2>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          maxWidth: "100%",
          ...this.content.value?.textAlign ? { alignSelf: { left: "flex-start", right: "flex-end", center: "center" }[this.content.value.textAlign] } : {}
        }
      }
    ];
  }
};
XH2Extension = __decorateClass([
  customElement("x-h2-extension")
], XH2Extension);
export {
  H2Extension,
  XH2Extension
};
